import AccountingAccountList from "../components/accounting-accounts/AccountingAccountCrud";

const AccountingAccountPage = () => {
  return (
    <>
      <AccountingAccountList />
    </>
  );
};

export default AccountingAccountPage;
